import { requestBuilder } from '../../../http/RequestBuilder';
import type { PaycheckRoutingConfig } from '../../types/PaycheckRouting';

const useSavePaycheckConfig = requestBuilder.mutation<
    PaycheckRoutingConfig,
    Partial<PaycheckRoutingConfig>
>({
    endpoint: '/api/paycheck-routing/create',
    method: 'POST',
});

export default useSavePaycheckConfig;
